module.exports = __webpack_public_path__ + "img/df979f9f2ebbed2f9fb86dcc4f9448a0.png";